var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.5C24 18.4897 19.6116 23.4542 13.875 24.3542V15.9688H16.6711L17.2031 12.5H13.875V10.2491C13.875 9.29984 14.34 8.375 15.8306 8.375H17.3438V5.42188C17.3438 5.42188 15.9703 5.1875 14.6573 5.1875C11.9166 5.1875 10.125 6.84875 10.125 9.85625V12.5H7.07812V15.9688H10.125V24.3542C4.38844 23.4542 0 18.4897 0 12.5C0 5.87281 5.37281 0.5 12 0.5C18.6272 0.5 24 5.87281 24 12.5Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6711 15.9688L17.2031 12.5H13.875V10.249C13.875 9.30003 14.3399 8.375 15.8306 8.375H17.3438V5.42188C17.3438 5.42188 15.9705 5.1875 14.6576 5.1875C11.9165 5.1875 10.125 6.84875 10.125 9.85625V12.5H7.07812V15.9688H10.125V24.3542C10.736 24.45 11.3621 24.5 12 24.5C12.6379 24.5 13.264 24.45 13.875 24.3542V15.9688H16.6711Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook11);
export default __webpack_public_path__ + "static/media/facebook 1 (1).53c96c29a36b495a7986806d4e9bb258.svg";
export { ForwardRef as ReactComponent };